var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
let WhatsApp = class WhatsApp extends Vue {
    constructor() {
        super(...arguments);
        this.selectedPhone = '';
        this.selectedMessageModel = '';
        this.message = '';
    }
    get messageModelOptions() {
        return [
            {
                label: 'Solicitar envio de mensagem',
                value: `Olá, esse é o whatsapp da empresa *${this.companyName}*? Posso mandar uma mensagem por aqui mesmo?`,
            },
            {
                label: 'Confirmar telefone',
                value: `Olá, este é o whatsapp de *${this.administratorName}* da empresa *${this.companyName}*?`,
            },
            {
                label: 'Contato do responsável',
                value: `Gostaria de falar com algum responsável da empresa *${this.companyName}*, você poderia informar o melhor telefone e email de contato?`,
            },
            {
                label: 'Follow up de whatsapp',
                value: 'Olá, conseguiu ler minha mensagem anterior?',
            },
            {
                label: 'Follow up de email',
                value: 'Olá, conseguiram ler o email que mandei para vocês?',
            },
        ];
    }
    get companyName() {
        return (this.company && this.company.name) || '';
    }
    get administratorName() {
        return ((this.company &&
            this.company.administratorData &&
            this.company.administratorData.name) ||
            '');
    }
    changedModel(e) {
        this.message = e.value;
    }
    async submit(type) {
        // @ts-ignore
        const valid = await this.$refs.whatsappForm.validate();
        if (!valid)
            return;
        let link;
        if (type == 'app') {
            link = `https://api.whatsapp.com/send?phone=${this.selectedPhone}&text=${encodeURIComponent(this.message)}`;
        }
        else {
            link = `https://web.whatsapp.com/send?phone=${this.selectedPhone}&text=${encodeURIComponent(this.message)}`;
        }
        window.open(link, 'popup', 'height=600,width=1000');
    }
};
__decorate([
    Prop({ default: () => ({}) })
], WhatsApp.prototype, "company", void 0);
__decorate([
    Prop({ default: () => [] })
], WhatsApp.prototype, "phoneOptions", void 0);
WhatsApp = __decorate([
    Component({
        name: 'WhatsApp',
    })
], WhatsApp);
export default WhatsApp;
